export const random = () => {
    return +(Math.random()*1000000000000).toFixed()
}
